import React from 'react';

function LogoFooter() {
  return (
    <div className='lg:w-3/12 w-full my-auto p-4 text-center'>
      <div className='flex justify-center moveSVG'>
        <img
          src='https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/gsteplogo.png?alt=media&token=37873c78-7f7c-4b42-9264-925e069a522b'
          alt='img'
          className='w-36'
        />
      </div>
      <p className='mt-12 text-xl text-gray700'>انطلق نحو التميز والابداع وكن مع GE Step</p>
    </div>
  );
}

export default LogoFooter;
